import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AssignmentReturnedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"assignment_returned"}/>
}
